import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Cards } from '../..';
export const _frontmatter = {
  "title": "Packages"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "packages"
    }}>{`Packages`}</h1>
    <p>{`In addition to the core library, Theme UI includes several optional packages.`}</p>
    <Cards width={320} mdxType="Cards">
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/core"
          }}>{`@theme-ui/core`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/components"
          }}>{`@theme-ui/components`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/mdx"
          }}>{`@theme-ui/mdx`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/presets"
          }}>{`@theme-ui/presets`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/prism"
          }}>{`@theme-ui/prism`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/color"
          }}>{`@theme-ui/color`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/style-guide"
          }}>{`@theme-ui/style-guide`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/editor"
          }}>{`@theme-ui/editor`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/gatsby-plugin"
          }}>{`gatsby-plugin-theme-ui`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/gatsby-theme-style-guide"
          }}>{`gatsby-theme-style-guide`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/gatsby-theme-ui-blog"
          }}>{`gatsby-theme-ui-blog`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/typography"
          }}>{`@theme-ui/typography`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/match-media"
          }}>{`@theme-ui/match-media`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/sidenav"
          }}>{`@theme-ui/sidenav`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/tachyons"
          }}>{`@theme-ui/tachyons`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/packages/tailwind"
          }}>{`@theme-ui/tailwind`}</a></li>
      </ul>
    </Cards>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      